export default __webpack_public_path__ + "static/media/p4-11.a173f33c.png";